import type { ShipmentDetail } from '@/services/shipping/types';

export const getUpdateShipmentInput = (data: ShipmentDetail) => {
  const {
    date,
    needByDate,
    originalNeedByDate,
    amount,
    tank,
    trackingNumber,
    requestedBy,
    phone,
    email,
    billTo,
    billStatus,
    comment,
    shipName,
    shipAddress,
    shipAddress2,
    shipAddress3,
    shipCity,
    shipState,
    shipZip,
    callTag,
    shipmentCategory,
    shipmentStatus,
    shippingMethod,
    hasEmbryos,
    hasSemen,
    hasDonors,
    hasRecipients,
    hasCalves,
    ownerId,
    packedById,
    shipFromSiteId,
  } = data;

  const shipToId = data?.shipTo?.id;

  return {
    date,
    needByDate,
    originalNeedByDate,
    amount,
    tank,
    trackingNumber,
    requestedBy,
    phone,
    email,
    billTo,
    billStatus,
    comment,
    shipName,
    shipAddress,
    shipAddress2,
    shipAddress3,
    shipCity,
    shipState,
    shipZip,
    callTag,
    shipmentCategory,
    shipmentStatus,
    shippingMethod,
    hasEmbryos,
    hasSemen,
    hasDonors,
    hasRecipients,
    hasCalves,
    ownerId,
    packedById,
    shipFromSiteId,
    shipToId,
  };
};

export const adjustDate = (dateString: string | number | Date) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  const adjustedDate = new Date(
    date.getTime() + date.getTimezoneOffset() * 60000,
  );
  return adjustedDate;
};

export const extractIds = (
  arr: unknown[] | undefined,
): string[] | undefined => {
  if (!Array.isArray(arr)) return undefined;
  return arr.map((e: any) => e?.id ?? e).filter(Boolean);
};
